import React from 'react';
import { AuthorName, AuthorsNameList, AuthorImage, AuthorsImageList, dateFormatter } from './utils';
import { formatter } from '../../../isomorphic/utils';
import TimeAgo from 'react-timeago';

export function MultipleAuthorTemplate({textStory, authors = [], showDateOnly = false, config = {}, hideImage = false, isLink, authorNameKeyword, storyPubKeyword, date}) {
  const authorsLength = authors.length;
  const publishKeyword = !showDateOnly && get(config, ['theme-attributes', 'lang'] !== 'ar') ? 'Published on : ' : '';
  const getTimeStamp = textStory === 'photo-low-priority' ?
  <TimeAgo date={date} formatter={(value, unit, suffix, date, defaultFormatter) => formatter(value, unit, suffix, date, defaultFormatter, config)} />
  : <TimeAgo date={date} formatter={(value, unit, suffix, date, defaultFormatter) => dateFormatter(value, unit, suffix, date, defaultFormatter, config)}/>

  return <div className="author author--multiple">
    <div className="author__avatars">
      { !hideImage && <AuthorsImageList authors={authors} isLink={isLink} /> }
    </div>
    <div className="author__content">
      { authorNameKeyword }
      <AuthorsNameList authors={authors} authorsLength={authorsLength} isLink={isLink} />
      <div className={`author__published-date ${textStory === 'photo-low-priority' ? 'time-wrapper' : ''}`}>
      { storyPubKeyword || (publishKeyword && <span className="pub-keyword">{publishKeyword}</span>) }
      <div className="author__time-stamp-wrapper">
      {getTimeStamp}
      </div>
      </div>
    </div>
  </div>
}